module.exports = __webpack_public_path__ + "static/media/black-hoodie-back-min.57c13114.png";